import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles(() => ({
  title: {
    fontSize: '1rem',
    fontWeight: 'bold',
    lineHeight: '1.5'
  },
  sectionTitle: {
    fontSize: '1.25rem',
    fontWeight: 'bold',
    lineHeight: '1.5',
    marginBottom: '16px'
  },
  input: {
    width: '100%',
    '& .MuiFormHelperText-contained': {
      margin: '0 !important'
    }
  },
  selectInput: {
    width: '100%'
  },
  buttonApply: {
    backgroundColor: '#159B78',
    color: 'white',
    height: '56px',
    width: '100px'
  }
}));
